import React from 'react';

/**
 * PlotContent
 *
 * Renders the plot structure in a single scrollable view:
 * Themes → Central Conflict → Plot Points → Resolution
 *
 * Props:
 * - plotStructure: object - the plot data
 */
export default function PlotContent({ plotStructure }) {
  if (!plotStructure) {
    return (
      <div className="plot-modal-empty">
        <p>No plot structure available yet.</p>
        <p style={{ marginTop: '8px', fontSize: '14px', color: 'var(--text-3)' }}>
          Run the agent to generate a plot analysis.
        </p>
      </div>
    );
  }

  return (
    <div className="plot-tab-panel">
      {/* Themes */}
      {plotStructure.themes && plotStructure.themes.length > 0 && (
        <div className="plot-section-compact themes-section">
          <div className="section-label">Themes</div>
          <div className="themes-compact">
            {plotStructure.themes.map((theme, index) => (
              <span key={index} className="theme-pill">{theme}</span>
            ))}
          </div>
        </div>
      )}

      {/* Central Conflict */}
      {plotStructure.mainConflict && (
        <div className="plot-section-compact">
          <div className="section-label">Central Conflict</div>
          <p className="section-text">{plotStructure.mainConflict}</p>
        </div>
      )}

      {/* Plot Points */}
      {plotStructure.plotPoints && plotStructure.plotPoints.length > 0 && (
        <div className="plot-section-compact">
          <div className="section-label">Plot Points</div>
          <div className="plot-timeline">
            {plotStructure.plotPoints.map((point, index) => (
              <div key={index} className={`timeline-item ${point.significance}`}>
                <div className="timeline-marker">
                  <span className="chapter-num">Ch {point.chapterNumber}</span>
                </div>
                <div className="timeline-content">
                  <div className="timeline-header">
                    <strong className="plot-element-name">{point.plotElement}</strong>
                    <span className={`sig-dot ${point.significance}`} title={`${point.significance} significance`}>●</span>
                  </div>
                  <p className="timeline-description">{point.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Resolution */}
      {plotStructure.resolution && (
        <div className="plot-section-compact">
          <div className="section-label">Resolution</div>
          <p className="section-text">{plotStructure.resolution}</p>
        </div>
      )}
    </div>
  );
}

function CharacterArcsPanel({ plotStructure }) {
  if (!plotStructure.characterArcs || plotStructure.characterArcs.length === 0) {
    return (
      <div className="plot-tab-panel">
        <div className="plot-tab-empty">No character arcs detected yet.</div>
      </div>
    );
  }

  return (
    <div className="plot-tab-panel">
      <div className="plot-section-compact">
        <div className="character-grid">
          {plotStructure.characterArcs.map((arc, index) => (
            <div key={index} className="character-card">
              <div className="character-name-badge">{arc.character}</div>
              <p className="character-arc-compact">{arc.arc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function ResolutionPanel({ plotStructure }) {
  if (!plotStructure.resolution) {
    return (
      <div className="plot-tab-panel">
        <div className="plot-tab-empty">No resolution detected yet.</div>
      </div>
    );
  }

  return (
    <div className="plot-tab-panel">
      <div className="plot-section-compact resolution-section">
        <div className="section-label">Resolution</div>
        <p className="section-text">{plotStructure.resolution}</p>
      </div>
    </div>
  );
}
